import {
  CardActions,
  CardContent,
  CardHeader,
  Dialog,
  FormControl,
  FormHelperText,
  Grid,
  Paper,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CVService } from "../../../../../service/CVService";
import AppButton from "../../../shares/AppButton";
import useToast from "../../../../../hooks/useToast";
import { TYPE_NOTIFICATION } from "../../../shares/NotificationBull";

const INIT_CV = {
  description: "",
};

const INIT_FORM_ERROR = {
  description_error: null,
};

const CVForm = ({ open, onFormClose, onFormOpen, id_cv = null }) => {
  const [currentCV, setCurrentCV] = useState(INIT_CV);
  const [formErrors, setFormErrors] = useState(INIT_FORM_ERROR);
  const [submited, setSubmited] = useState(false);
  const { Toast, showToast } = useToast();
  const navigate = useNavigate();

  const handleFormClose = () => {
    onFormClose();
  };

  const handleChangeCVData = (e) => {
    const { name, value } = e.target;
    setCurrentCV({ ...currentCV, [name]: value });
  };

  const handleCheckDataValidation = () => {
    setFormErrors({
      description_error: !currentCV.description
        ? "Le champ desciption est requis"
        : null,
    });
    return Object.values(formErrors).every((error) => error === null);
  };

  const handleInsertCV = () => {
    setSubmited(true);
    CVService.insertCV(currentCV)
      .then((res) => {
        if (res && res.success) {
          showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
          handleFormClose();
          navigate(`/mon-profile/cv?ref=${res.data.id_user}`);
        } else {
          showToast(TYPE_NOTIFICATION.ERROR, res.message);
        }
      })
      .finally(() => {
        setSubmited(false);
      });
  };
  const handleEditCV = () => {
    setSubmited(true);
    try {
      CVService.updateCV(currentCV)
        .then((res) => {
          if (res && res.success) {
            showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
            handleFormClose();
            // navigate(`/mes-associations/info?uuid=${res.data.uuid}`);
          } else {
            showToast(TYPE_NOTIFICATION.ERROR, res.message);
          }
        })
        .finally((e) => {
          setSubmited(false);
        });
    } catch (e) {
      
    }
  };

  const handleSubmit = () => {
    if (handleCheckDataValidation()) {
      if (currentCV.uuid) {
        handleEditCV();
      } else {
        handleInsertCV();
      }
    } else {
      showToast(TYPE_NOTIFICATION.ERROR, "Veuillez verifier les champs");
    }
  };

  useEffect(() => {
    if (currentCV) {
      handleCheckDataValidation();
    }
  }, [currentCV]);

  return (
    <>
      <Toast />
      <Dialog open={open} onClose={handleFormClose} fullWidth maxWidth="xs">
        <Paper sx={{ m: 3 }} elevation={0}>
          <Grid>
            <CardHeader title={id_cv ? "Modifier CV" : "Nouveau CV"} />
            <CardContent>
              <Grid container>
                <FormControl fullWidth>
                  <label>Description</label>
                  <TextField
                    id="description"
                    name="description"
                    onChange={handleChangeCVData}
                    size="small"
                    type="text"
                    // error={formErrors.nom_error}
                    value={currentCV.description || ""}
                    error={formErrors.description_error && submited}
                    helperText={submited ? formErrors.description_error : ""}
                    placeholder="Description"
                    fullWidth
                    aria-describedby="description_helper"
                  />
                  <FormHelperText id="description_helper"></FormHelperText>
                </FormControl>
              </Grid>
            </CardContent>
            <CardActions sx={{ justifyContent: "flex-end" }}>
              <AppButton
                text={"Enregistrer"}
                variant={"contained"}
                size={"medium"}
                onClick={(e) => handleSubmit()}
                />
              <AppButton
                size={"medium"}
                text={"Fermer"}
                variant={"outlined"}
                onClick={(e) => handleFormClose()}
              />
            </CardActions>
          </Grid>
        </Paper>
      </Dialog>
    </>
  );
};

export default CVForm;
